import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

import TokenList from '@wordpress/token-list';

import proportionalImageSizes from '../../../modules/proportional-image-sizes';

proportionalImageSizes( '.wp-block-gallery.is-style-logos img' );

const sliderGalleries = document.querySelectorAll(
	'.wp-block-gallery.is-style-slider'
);
sliderGalleries.forEach( ( gallery ) => {
	// Determine number of slides to show from columns class, default = 3.
	const classList = new TokenList( gallery.className );
	let columns = 3;
	// Is there a better way to do this?
	for ( let i = 1; i <= 8; i++ ) {
		if ( classList.contains( `columns-${ i }` ) ) {
			columns = i;
			break;
		}
	}

	// Add 'swiper' class to gallery.
	gallery.classList.add( 'swiper' );

	// Add 'swiper-slide' class to each image.
	const images = gallery.querySelectorAll( '.wp-block-image' );
	images.forEach( ( image ) => {
		image.classList.add( 'swiper-slide' );
	} );

	// Initialize Swiper.
	const swiper = new Swiper( gallery, {
		loop: true,
		grabCursor: true,
		createElements: true,
		centeredSlides: true,
		slidesPerView: 1,
		spaceBetween: 30,
		// Enable modules.
		modules: [ A11y, Keyboard, Navigation, Pagination ],
		navigation: true,
		pagination: true,
		breakpoints: {
			600: {
				slidesPerView: columns,
			},
		},
	} );
} );
